(function () {
  const API_URL = "https://clayimports.myshopify.com/api/2023-10/graphql.json";
  const TOKEN = "20c6f2d75ec1e14a68e2f86c034aa596";
  const CACHE = new Map();

  function findOriginalPriceEl(el) {
    const wrap = el.closest(".price__regular") || el.closest(".price-container") || el.parentElement;
    if (!wrap) return null;
    return (
      wrap.querySelector(".js-original-price") ||
      wrap.querySelector(".price-item") ||
      null
    );
  }

  function showCustom(el, text) {
    const original = findOriginalPriceEl(el);
    if (original) original.style.display = "none";
    if (text) el.textContent = text;
    el.hidden = false;
    el.style.display = "";
  }

  function showOriginal(el) {
    const original = findOriginalPriceEl(el);
    if (original) original.style.display = "";
    el.hidden = true;
    el.style.display = "none";
  }

  async function fetchPricePerSq(variantId) {
    if (CACHE.has(variantId)) return CACHE.get(variantId);

    const variantGID = `gid://shopify/ProductVariant/${variantId}`;
    const body = {
      query: `
        {
          node(id: "${variantGID}") {
            ... on ProductVariant {
              metafield(namespace: "calculator", key: "variant_calculator_new") {
                value
              }
            }
          }
        }
      `
    };

    const res = await fetch(API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": TOKEN
      },
      body: JSON.stringify(body),
      credentials: "omit"
    });

    const json = await res.json();
    const raw = json?.data?.node?.metafield?.value;
    let pricePerSq = null;

    if (raw) {
      try {
        const data = JSON.parse(raw);
        const v = data?.pricePerSq;
        if (v !== undefined && v !== null && !isNaN(Number(v))) {
          pricePerSq = Number(v);
        }
      } catch (e) {
        // noop
      }
    }

    CACHE.set(variantId, pricePerSq);
    return pricePerSq;
  }

  function waitForCustomPriceElements(maxAttempts = 10, delay = 500) {
    let attempts = 0;

    const tryLoad = () => {
      const priceEls = document.querySelectorAll(".custom-price:not([data-processed='true'])");
      if (!priceEls.length) {
        attempts++;
        if (attempts < maxAttempts) setTimeout(tryLoad, delay);
        return;
      }

      priceEls.forEach(async (el) => {
        if (el.closest(".slick-cloned")) return;
        el.dataset.processed = "true";

        const variantId = el.dataset.variantGid;
        if (!variantId) {
          showOriginal(el);
          return;
        }

        try {
          const pricePerSq = await fetchPricePerSq(variantId);
          if (typeof pricePerSq === "number") {
            showCustom(el, `$${pricePerSq.toFixed(2)} per sq ft`);
          } else {
            showOriginal(el);
          }
        } catch {
          showOriginal(el);
        }
      });
    };

    tryLoad();
  }

  function observePriceLoading() {
    const observer = new MutationObserver(() => {
      const hasTargets = document.querySelector(".custom-price:not([data-processed='true'])");
      if (hasTargets) waitForCustomPriceElements(10, 300);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener("DOMContentLoaded", () => {
    observePriceLoading();
    waitForCustomPriceElements(10, 300);
  });
})();
